<!-- HEADER -->
<div
  class="header flex justify-content-between lg:flex-nowrap flex-wrap bg-white"
>
  <div class="flex gap-3 align-content-end align-items-center">
    <img class="logo" src="./assets/icons/logo_top.png" />
    <div class="mb-10">
      <h2>{{ appTitle }}</h2>
      <h4>{{ appSubtitle }}</h4>
    </div>
  </div>
</div>
<hr class="shadow-1" />

<div class="stage-message" *ngIf="isStageEnvironment">
  <i class="pi pi-info-circle"></i> ΔΟΚΙΜΑΣΤΙΚΟ ΠΕΡΙΒΑΛΛΟΝ
</div>

<!-- BODY -->
<div class="flex justify-content-center min-height-50">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <div
      class="flex flex-column gap-4 mt-6 p-5 border-round surface-card shadow-1"
    >
      <div class="text-2xl mx-2 mb-1 mx-5">
        Εισάγετε το Α.Φ.Μ. και το ΑΜΚΑ για επαλήθευση
      </div>

      <eo-input
        label="Α.Φ.Μ."
        formControlName="afm"
        [errors]="gsisOAuth2FormConfig.getErrors('afm')"
      />

      <eo-input
        label="Α.Μ.Κ.Α."
        formControlName="amka"
        [errors]="gsisOAuth2FormConfig.getErrors('amka')"
        />

      <button
        pButton
        type="submit"
        label="Είσοδος στην Υπηρεσία"
        iconPos="right"
        class="p-button-primary"
        [disabled]="!form.valid || (status$ | async) === 'loading'"
        [loading]="(status$ | async) === 'loading'"
      ></button>
    </div>
  </form>
</div>

<!-- FOOTER -->
<div class="flex justify-content-between layout-footer">
  <p>
    Διεύθυνση Ηλεκτρονικής Διακυβέρνησης ΕΚΑΠΥ © 2024. Version
    {{ appVersion }}
  </p>
  <img
    style="padding-right: 180px"
    src="./assets/icons/ellada2.png"
    alt="Ellada Logo"
  />
  <p>{{ today }}</p>
</div>
